




























import {Vue, Component, Prop, Model} from 'vue-property-decorator'
import GradeItem from '@/components/board/GradeItem.vue';
import {GetBoards} from 'supporter'

@Component({
  name: 'SequenceList',
  components: {GradeItem}
})
export default class SequenceList extends Vue {
  @Prop({required: true})
  sequenceList!: GetBoards[]

  @Prop({required: true, type: String})
  addBtnName!: string

  @Prop({required: true, type: String})
  emptyHint!: string

  @Prop({required: true, type: Number})
  @Model('selectIndex')
  selectIndex!: number

  private inputIndex: number = -1

  private isGroupListEmpty(): boolean {
    return this.sequenceList && this.sequenceList.length === 0
  }

  private isGroupOnSelect(index: number): boolean {
    return this.selectIndex === index
  }

  private isGroupNameTap(index: number): boolean {
    return this.inputIndex === index
  }

  private onSelectItem(index: number): void {
    this.$emit('SELECT-ITEM', index)
  }

  private tempGradeName: string = '';
  private editFlg = false;  
  private onInputOn(index: number): void {
    this.inputIndex = index
    this.editFlg = true;
    let _this = this;
    this.$nextTick(() => {
      (_this.$refs.tempGradeName as any).focus();
    });    
  }

  private onInputDone(index: number, nameInfo: any): void {
    this.inputIndex = -1
    this.sequenceList[index].boardName = nameInfo.name
    this.editFlg = false;    
    this.$emit('CHANGE-LABEL-NAME', nameInfo)
  }
  private orderUp(): void {
    if (this.selectIndex > 0) {
      this.$emit('ORDER-UP', this.selectIndex)
    }
  }
  private orderDown(): void {
    if (this.selectIndex !== this.sequenceList.length) {
      this.$emit('ORDER-DOWN', this.selectIndex)
    }
  }
  private addGroup(): void {
    this.$emit('ADD')
  }
  private delGroup(): void {
    this.$emit('DELETE')
  }

}
